// eslint-disable-next-line object-curly-newline
import {
  mdiCarWindshield,
  mdiPackage,
  mdiLeafCircle,
  mdiSnowflake,
  mdiAccountTie,
  mdiBullhorn,
  mdiChefHat,
  mdiCog,
  mdiPhone,
  mdiCollage,
  mdiBottleTonic,
  mdiCakeVariant,
  mdiContactlessPayment,
  mdiCreditCard,
  mdiCashRegister,
  mdiEye,
  mdiFileDocument,
  mdiFileDocumentOutline,
  mdiHomeOutline,
  mdiOrderNumericAscending,
  mdiTimerSand,
  mdiBell,
  mdiSprayBottle,
  mdiRadar,
  mdiRoadVariant,
  mdiShape,
  mdiHanger,
  mdiStore,
  mdiTrayFull,
} from "@mdi/js";

import { v4 as uuidv4 } from "uuid";
const accessToken = localStorage.getItem("accessToken");

export default [
  // {
  //   key: uuidv4(),
  //   title: "Denetim Masası",
  //   icon: mdiHomeOutline,
  //   to: "dashboard",
  //   resource: "Dashboard",
  //   action: "read",
  // },

  {
    key: uuidv4(),
    title: "Yöneticiler",
    icon: mdiAccountTie,
    to: "manager-list",
    resource: "asl-managers",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Kullanıcılar",
    icon: mdiStore,
    to: "user-list",
    resource: "asl-users",
    action: "read",
  },
  {
    key: uuidv4(),
    subheader: "Mamül Ürünler",
    resource: "asl-text-mamul",
    action: "read",
  },

  {
    key: uuidv4(),
    title: "Taze",
    icon: mdiLeafCircle,
    to: { name: "order-to", params: { type: "taze" } },
    resource: "asl-order-mamul",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Donuk",
    icon: mdiSnowflake,
    to: { name: "order-to", params: { type: "donuk" } },
    resource: "asl-order-mamul",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Pasta Siparişi",
    icon: mdiCakeVariant,
    to: "order-cake",
    resource: "asl-order-mamul-easy",
    action: "read",
  },

  {
    key: uuidv4(),
    subheader: "Sarf Ürünler",
    resource: "asl-text-sarf",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Ambalaj",
    icon: mdiCarWindshield,
    to: { name: "order-to", params: { type: "ambalaj" } },
    resource: "asl-order-sarf",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Ekipman",
    icon: mdiCog,
    to: { name: "order-to", params: { type: "ekipman" } },
    resource: "asl-order-sarf",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Giyim",
    icon: mdiHanger,
    to: { name: "order-to", params: { type: "giyim" } },
    resource: "asl-order-sarf",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Hijyen",
    icon: mdiSprayBottle,
    to: { name: "order-to", params: { type: "hijyen" } },
    resource: "asl-order-sarf",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Paketli",
    icon: mdiPackage,
    to: { name: "order-to", params: { type: "paketli" } },
    resource: "asl-order-sarf",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Şişelenmiş",
    icon: mdiBottleTonic,
    to: { name: "order-to", params: { type: "siselenmis" } },
    resource: "asl-order-sarf",
    action: "read",
  },

  // {
  //   key: uuidv4(),
  //   title: "Kolay Sipariş Ver",
  //   icon: mdiBottleTonic,
  //   to: { name: "order-product", params: { type: "sarf" } },
  //   resource: "asl-order-sarf-easy",
  //   action: "read",
  // },

  {
    key: uuidv4(),
    subheader: "Ürünler",
    resource: "asl-text-product",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Mamül Ürünler",
    icon: mdiChefHat,
    to: "product-mamul",
    resource: "asl-products-mamul",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Sarf Ürünler",
    icon: mdiCollage,
    to: "product-sarf",
    resource: "asl-products-sarf",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Çağrı Merkezi Ürünleri",
    icon: mdiPhone,
    to: "product-call",
    resource: "asl-products-callcenter",
    action: "read",
  },
  {
    key: uuidv4(),
    subheader: "Ödeme & Takip",
    resource: "asl-text-payment-tracking",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Manuel Ödeme",
    icon: mdiContactlessPayment,
    to: "payment",
    resource: "asl-manual-payment",
    action: "read",
  },
  {
    key: uuidv4(),
    subheader: "Takip",
    resource: "asl-text-tracking",
    action: "read",
  },

  {
    key: uuidv4(),
    title: "Siparişler",
    icon: mdiOrderNumericAscending,
    to: "order-tracking",
    resource: "asl-order-tracking",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Bekleyen Siparişler",
    icon: mdiTimerSand,
    to: "order-approval",
    resource: "asl-order-confirmation",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Çağrı Merkezi Takip",
    icon: mdiBell,
    to: "call-center-list",
    resource: "asl-callcenter-tracking",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Kredi Kartı Takip",
    icon: mdiCreditCard,
    to: "credit-card-transactions",
    resource: "asl-payment-tracking",
    action: "read",
  },

  // {
  //   key: uuidv4(),
  //   title: "Talep Takip",
  //   icon: mdiCommentAlert,
  //   to: "complaint-request",
  //   resource: "asl-request-tracking",
  //   action: "read",
  // },
  {
    key: uuidv4(),
    subheader: "Raporlama",
    resource: "asl-text-report",
    action: "read",
  },
  // {
  //   key: uuidv4(),
  //   title: "Cari Bilgiler",
  //   icon: mdiShieldAccount,
  //   to: { name: "user-view" },
  //   resource: "asl-customer-information",
  //   action: "read",
  // },
  {
    key: uuidv4(),
    title: "Kasa Raporları",
    icon: mdiCashRegister,
    to: "cash-report",
    resource: "asl-cash-report",
    action: "read",
    new: true,
  },
  {
    key: uuidv4(),
    title: "Satış Belgeleri",
    icon: mdiFileDocument,
    resource: "asl-sales-document",
    action: "read",
    children: [
      {
        key: uuidv4(),
        title: "Siparişler",
        to: { name: "documents-list", params: { folder: "order" } },
        resource: "asl-sales-document-order",
        action: "read",
      },

      {
        key: uuidv4(),
        title: "İrsaliyeler",
        to: { name: "documents-list", params: { folder: "waybill" } },
        resource: "asl-sales-document-waybill",
        action: "read",
      },
      {
        key: uuidv4(),
        title: "Faturalar",
        to: { name: "documents-list", params: { folder: "bill" } },
        resource: "asl-sales-document-invoice",
        action: "read",
      },
      {
        key: uuidv4(),
        title: "Hizmet Faturalar",
        to: { name: "documents-list", params: { folder: "HF" } },
        resource: "asl-sales-document-service-invoice",
        action: "read",
      },
      {
        key: uuidv4(),
        title: "Yansıtma Faturalar",
        to: { name: "documents-list", params: { folder: "Y1" } },
        resource: "asl-sales-document-mirroring-invoice",
        action: "read",
      },
      {
        key: uuidv4(),
        title: "İade  Faturalar",
        to: { name: "documents-list", params: { folder: "R1" } },
        resource: "asl-sales-document-return-invoice",
        action: "read",
      },
    ],
  },
  {
    key: uuidv4(),
    title: "Ekstre",
    icon: mdiTrayFull,
    to: "extract-list",
    resource: "asl-extract",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Ödemeler",
    icon: mdiRadar,
    to: "payment-tracking",
    resource: "asl-payments",
    action: "read",
  },
  {
    key: uuidv4(),
    subheader: "Sistem & Ayarlar",
    resource: "asl-text-system-setting",
    action: "read",
  },
  {
    title: "DBS",
    icon: mdiEye,
    to: "dbs-list",
    resource: "asl-dbs",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Root",
    icon: mdiRoadVariant,
    to: "root",
    resource: "asl-root",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Kategoriler",
    icon: mdiShape,
    to: "product-category",
    resource: "asl-categories",
    action: "read",
  },
  {
    title: "Duyurular",
    icon: mdiBullhorn,
    to: "event-list",
    resource: "asl-notifications",
    action: "read",
  },

  {
    key: uuidv4(),
    title: "Ayarlar",
    icon: mdiCog,
    to: "settings-view",
    resource: "asl-settings",
    action: "read",
  },
  {
    key: uuidv4(),
    title: "Integrations",
    href: `${process.env.VUE_APP_URL}tr/integrations?token=${accessToken}`,
    icon: mdiFileDocumentOutline,
    resource: "asl-integrations",
    action: "read",
  },
];
